import React from 'react';

import ComponentWrapper from './ComponentWrapper';
import * as legacyComponents from './legacyComponents';
import * as components from './components';

// Pure, side-effect-free seams for the SDK's renderComponent (which itself lives in
// index.js, a bootstrap module). Kept here so they can be unit-tested with a plain
// import, without triggering the SDK bootstrap.

// Resolve an SDK component by name. Returns the component (or undefined if the name is
// unknown) and whether it came from the legacy set.
export function resolveSdkComponent(componentName) {
  return {
    Component: components[componentName] || legacyComponents[componentName],
    isLegacyComponent: !!legacyComponents[componentName]
  };
}

// Build the per-component content that renderComponent mounts: the resolved component,
// wrapped in ComponentWrapper (flagged legacy for legacy components).
export function buildComponentContent({ Component, isLegacyComponent, props }) {
  return (
    <ComponentWrapper legacy={isLegacyComponent}>
      <Component {...props} />
    </ComponentWrapper>
  );
}
